import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';
import StatusChip from '../home/setting-modal/status-chip';
import { EXERCISE_STATUS, normalizeExerciseStatus } from '../../utilis/exercise-status';
import { usePrefetchedMediaSrc } from '../../hooks';

const ExerciseCard = ({ title, setNumber, totalSets, status, imageUrl, isFlipped }) => {
  const { t } = useTranslation('exercise');
  const resolvedImageSrc = usePrefetchedMediaSrc(imageUrl);
  // Accept either the numeric code or the backend's string token — this card is
  // also rendered from payloads that haven't been through the socket normalizer.
  const statusCode = normalizeExerciseStatus(status);
  const isCurrent = statusCode === EXERCISE_STATUS.CURRENT;

  return (
    <div
      tw="px-[12px] py-[12px] flex gap-[12px] items-center min-h-[84px] lg:min-h-[100px] rounded-[12px] w-full"
      css={
        isCurrent
          ? tw`bg-[#F7FAEB] border border-[#718122]`
          : tw`bg-white border border-[#BDC4C9] lg:bg-[#F3F3F3] lg:border-transparent`
      }
    >
      <div tw="h-[60px] w-[80px] min-w-[80px] overflow-hidden rounded-[6px]">
        <img
          loading="lazy"
          decoding="async"
          css={isFlipped ? tw`scale-x-[-1]` : tw``}
          src={resolvedImageSrc}
          alt={t('exerciseCard.altExercise')}
          tw="object-cover w-full h-full"
        />
      </div>
      <div tw="flex flex-1 flex-col gap-[4px] min-w-0">
        <p tw="text-[16px] lg:text-[20px] font-semibold text-[#2E2E2E] lg:truncate">{title}</p>
        {isCurrent && setNumber > 0 && (
          <p tw="text-[16px] lg:text-[20px] font-medium text-gray-text">
            {totalSets > 0
              ? t('exerciseCard.setWithTotal', { current: setNumber, total: totalSets })
              : t('exerciseCard.setOnly', { current: setNumber })}
          </p>
        )}
      </div>
      <StatusChip status={statusCode} />
    </div>
  );
};

export default ExerciseCard;
